
import React from 'react';
import { Button } from "@/components/ui/button";
import { Eye, EyeOff, LogOut } from 'lucide-react';

interface ProviderControlsProps {
  isAuthenticated: boolean;
  isProviderView: boolean;
  toggleProviderView: () => void;
  logout: () => void;
}

const ProviderControls: React.FC<ProviderControlsProps> = ({ 
  isAuthenticated, 
  isProviderView, 
  toggleProviderView, 
  logout 
}) => {
  if (!isAuthenticated) return null;
  
  return (
    <div className="flex items-center gap-2">
      <Button 
        variant="outline" 
        size="sm" 
        className="h-9" 
        onClick={toggleProviderView}
      >
        {isProviderView ? <EyeOff className="mr-2 h-4 w-4" /> : <Eye className="mr-2 h-4 w-4" />}
        Clinical
      </Button>
      
      <Button 
        variant="ghost" 
        size="icon" 
        className="h-9 w-9 text-muted-foreground" 
        onClick={logout}
        title="Logout"
      >
        <LogOut className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ProviderControls;
